<loren-page-content>
    <mat-card-title>{{ "toolbar.geofencing" | transloco }}</mat-card-title>
  <div
    leaflet
    #mapWrapper
    leafletDraw
    [style.width]="'100%'"
    [style.height]="(mapHeight$ | async) + 'px'"
    [leafletDrawOptions]="drawOptions"
    (leafletMapReady)="onMapReady($event)"
    (leafletClick)="handleMapClick()"
    (leafletDrawCreated)="handleDrawCreated($event)"
    (leafletDrawEditResize)="handleMoveResize($event)"
    (leafletDrawEditMove)="handleMoveResize($event)"
    [leafletMarkerCluster]="markerClusterData"
    [leafletMarkerClusterOptions]="markerClusterOptions"
    (leafletMapMoveEnd)="handleMapMove()"
    (leafletMarkerClusterReady)="markerClusterReady($event)"
    [leafletOptions]="options"
  ></div>

  @if (!isDrawing && !isEditing) {
    <loren-expansion-panel
      #zonesPanel
      class="zones-list-wrapper"
      [panelTitle]="'geofencing.zones' | transloco"
      [matTooltip]="'tooltips.show_geofences' | transloco"
      [style.opacity]="listSelectorOpacity"
      [style.width.%]="100"
      (mouseenter)="changeListSelectorOpacity(1)"
      (mouseleave)="changeListSelectorOpacity(0.8)"
      (expanded)="calculateAddButtonBottomOffset()"
      (collapsed)="calculateAddButtonBottomOffset()"
      >
      <div class="row">
        <div class="col">
          <div class="row search-content">
            <div class="col-md-6">
              <form>
                <mat-form-field class="example-full-width loren-form-field">
                  <mat-label>{{ "operations.search" | transloco }}</mat-label>
                  <input
                    #searchInput
                    matInput
                    (keyup)="search(searchInput.value)"
                    />
                  @if (searchInput.value) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="searchInput.value = ''; refreshAllZonesList()"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col zones-list">
              <loren-map-zones-list
                [zones]="allZones"
                (zoneClick)="fitBoundsToZone($event)"
                (zoneDeleteClick)="openDeleteModal(allZonesMap.get($event))"
                (zoneEditClick)="handleZoneEditFromList($event)"
                >
              </loren-map-zones-list>
            </div>
          </div>
        </div>
      </div>
    </loren-expansion-panel>
  }

  <ng-container *lorenShowForPrivileges="[privileges.WRITE_GEOFENCE_ZONES]">
    @if (!isDrawing && !isEditing) {
      <button
        #addZoneBtn
        matFab
        class="on-map"
        [style.bottom.px]="addButtonBottomOffset"
        [matTooltip]="'tooltips.create_new_geofence' | transloco"
        (click)="openShapeCreationDialog()"
        >
        <mat-icon>add</mat-icon>
      </button>
    }
  </ng-container>

  <!-- Additional options for shapes different than circle -->
  @if (isDrawing && currentlyDrawnShapeType === shapeTypes.POLYGON) {
    <div
      class="on-map"
      >
      <!-- Delete last point and finish options for polygon -->
      <ng-container>
        <button
          [disabled]="polygonPointsDrawn < 3"
          matButton="filled"
          class="mr-1"
          (click)="finishPolygon()"
          >
          @if (!isHandset) {
            {{ "geofencing.finish_polygon" | transloco }}
          }
          @if (isHandset) {
            <mat-icon>done</mat-icon>
          }
        </button>
        <button
          [disabled]="polygonPointsDrawn < 2"
          matButton="filled"
          class="mr-1"
          (click)="deleteLastPolygonPoint()"
          >
          @if (!isHandset) {
            {{ "geofencing.delete_last_polygon_point" | transloco }}
          }
          @if (isHandset) {
            <mat-icon>undo</mat-icon>
          }
        </button>
      </ng-container>
      <!-- Cancel -->
      <button
        matButton="filled"
        class="me-1 btn-secondary"
        (click)="cancelShapeCreation()"
        >
        <ng-container>
          {{ "operations.cancel" | transloco }}
        </ng-container>
      </button>
    </div>
  }

  @if (isEditing) {
    <div class="on-map">
      <button matButton="filled"
        class="btn-secondary me-1" (click)="cancelEdit()">
        <ng-container>
          {{ "operations.cancel" | transloco }}
        </ng-container>
      </button>
      <button matButton="filled"
        class="me-1"
        (click)="saveChanges()"
        >
        <ng-container>
          {{ "operations.save" | transloco }}
        </ng-container>
      </button>
    </div>
  }

  <ng-container
    *lorenFeatureToggle="lorenFeatures.GENERIC_MAP_LAYERS_VISUALIZATION"
    >
    @if (!isDrawing && !isEditing) {
      <loren-layer-selection
        [allMapLayers]="allMapLayers"
        [lastSelectedLayers]="lastSelectedLayers"
        [buttonBottomOffset]="layerBtnBottomOffset"
        [btnLook]="'layer-selection-btn'"
        (finishLayerSelection)="handleLayerSelection($event)"
        >
      </loren-layer-selection>
    }
  </ng-container>
</loren-page-content>
